import { Component, OnInit } from '@angular/core';

@Component({
	selector: 'hpf-module-en-savoir-plus',
	templateUrl: './module-en-savoir-plus.component.html',
})
export class ModuleEnSavoirPlusComponent implements OnInit {
	/** Constructor */
	constructor() {}

	/** Init */
	ngOnInit() {}
}
